import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pumpicon-stopline",
  "use": "icon-pumpicon-stopline-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pumpicon-stopline\">\n  <g id=\"icon-pumpicon-stopline_位移矩形\" transform=\"translate(0, 0)\">\n    <g id=\"icon-pumpicon-stopline_红线\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n      <path d=\"M0,7 l14,0\" id=\"icon-pumpicon-stopline_红线\" stroke=\"#DF432A\" stroke-width=\"2\" />\n    </g>\n  </g>  \n</symbol>"
});
var result = sprite.add(symbol);
export default symbol